/* ============================================================================
   CRUX — FUNCTION LAYER  ·  assets/crux-upgrades.js  (vet build 2026-07-02)
   Adds behaviour only — no layout changes. Vanilla classic script (IIFE),
   same idiom as crux-redesign.js. Everything fails OPEN.

     §1  Card v2 size tray — "+" adds in place for single-option products
         (hover-prefetched /products/{handle}.js); multi-option products keep
         the quick-add modal. "Added ✓" overlay on success.
     §2  PDP motion pass — gallery stagger-in, price morph on variant change,
         add-to-cart success pop. Reveal engine + pub/sub reused.
     §3  Cart drawer intelligence — "Complete your cart" styled by EON
         (/cart-look, one-tap add), REAL restock urgency on line items
         (/social-proof), survives drawer re-renders (the old inline <script>
         died after the first renderContents — innerHTML never executes it).
     §4  Search drawer — "Popular right now" chips (real ranking, honest label).
     §5  Ask EON dock — on-site stylist (POST /api/storefront/ask), quick
         chips, product cards, cart/product context. Gated by theme setting.
     §6  Drop scene — IO fallback for browsers without scroll-timeline.
   ============================================================================ */
(function () {
  'use strict';

  var REDUCE = false;
  try { REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ngn(n) { return '₦' + Math.round(n || 0).toLocaleString('en-NG'); }
  function eonCfg() {
    var C = window.EON_STOREFRONT;
    if (!C || !C.enabled || !C.base) return null;
    return { base: String(C.base).replace(/\/+$/, ''), shop: encodeURIComponent(C.shop || ''), raw: C };
  }
  function track(ev, payload) {
    try { if (window.EON && window.EON.track) window.EON.track(ev, payload || {}); } catch (e) {}
  }

  // AJAX add + drawer refresh (same contract as crux-redesign's eonAddToCart,
  // duplicated minimally here so this file stands alone).
  function cxAdd(variantId, done) {
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) { if (done) done(false); return; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(function (rr) { return rr.ok ? rr.json() : null; })
          .then(function (sections) { if (sections) drawer.renderContents({ sections: sections }); })
          .catch(function () {});
      } else {
        fetch('/cart.js').then(function (rr) { return rr.json(); }).then(function (c) {
          $all('.cart-count-bubble, .cart-count, [data-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
          try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'crux-upgrades', cartData: c }); } catch (e) {}
        }).catch(function () {});
      }
      if (done) done(true);
    }).catch(function () { if (done) done(false); });
  }

  /* ========================================================================
     §1 CARD V2 — in-card size tray
     ===================================================================== */
  var productCache = {};
  function prefetchProduct(handle) {
    if (!handle || productCache[handle]) return;
    productCache[handle] = { pending: true };
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p || { failed: true }; })
      .catch(function () { productCache[handle] = { failed: true }; });
  }
  function trayEligible(p) {
    if (!p || p.failed || p.pending || !p.variants || !p.options) return false;
    if (p.options.length !== 1) return false;
    var avail = p.variants.filter(function (v) { return v.available; });
    return avail.length >= 1 && p.variants.length <= 8;
  }
  function openTray(card, p) {
    var wrap = $('.cx-pcard__mediawrap', card);
    if (!wrap) return false;
    var tray = $('.cx-pcard__tray', wrap);
    if (!tray) {
      tray = document.createElement('div');
      tray.className = 'cx-pcard__tray';
      tray.setAttribute('role', 'group');
      tray.setAttribute('aria-label', 'Pick a size');
      tray.innerHTML = p.variants.map(function (v) {
        return '<button type="button" data-vid="' + esc(v.id) + '"' + (v.available ? '' : ' class="is-oos" disabled') + '>' + esc(v.option1) + '</button>';
      }).join('');
      wrap.appendChild(tray);
      on(tray, 'click', function (ev) {
        var b = ev.target.closest && ev.target.closest('button[data-vid]');
        if (!b || b.disabled) return;
        ev.preventDefault(); ev.stopPropagation();
        b.disabled = true;
        cxAdd(b.getAttribute('data-vid'), function (ok) {
          b.disabled = false;
          tray.classList.remove('is-open');
          if (ok) {
            var added = $('.cx-pcard__added', wrap);
            if (!added) {
              added = document.createElement('div');
              added.className = 'cx-pcard__added';
              added.textContent = 'Added ✓';
              wrap.appendChild(added);
            }
            added.classList.add('is-on');
            setTimeout(function () { added.classList.remove('is-on'); }, 1500);
            track('card_tray_add', { handle: p.handle, variant_id: b.getAttribute('data-vid') });
          }
        });
      });
      // close when the pointer leaves the card
      on(card, 'mouseleave', function () { tray.classList.remove('is-open'); });
    }
    tray.classList.toggle('is-open');
    return true;
  }
  function initCardTray() {
    // hover/touch prefetch so the click decision is synchronous
    on(document, 'mouseover', function (ev) {
      var card = ev.target.closest && ev.target.closest('.cx-pcard');
      if (!card || card.__cxPre) return; card.__cxPre = 1;
      var btn = $('[data-cx-qadd]', card);
      if (btn) prefetchProduct(btn.getAttribute('data-cx-qadd'));
    }, { passive: true });
    on(document, 'touchstart', function (ev) {
      var card = ev.target.closest && ev.target.closest('.cx-pcard');
      if (!card || card.__cxPre) return; card.__cxPre = 1;
      var btn = $('[data-cx-qadd]', card);
      if (btn) prefetchProduct(btn.getAttribute('data-cx-qadd'));
    }, { passive: true });
    // capture-phase: claim the click before the quick-add modal binding
    on(document, 'click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('.cx-pcard [data-cx-qadd]');
      if (!btn) return;
      var card = btn.closest('.cx-pcard');
      var p = productCache[btn.getAttribute('data-cx-qadd')];
      if (!card || !trayEligible(p)) return; // fall through to the modal
      ev.preventDefault();
      ev.stopPropagation();
      openTray(card, p);
    }, true);
  }

  /* ========================================================================
     §2 PDP MOTION PASS
     ===================================================================== */
  function initPdpMotion() {
    if (!document.body.className.match(/template-product/)) return;
    // gallery stagger-in (once, on boot; skipped for reduced motion)
    if (!REDUCE) {
      var media = $all('.product__media-item, .product__media-list li').slice(0, 8);
      media.forEach(function (m, i) {
        m.style.opacity = '0';
        m.style.transform = 'translateY(14px)';
        m.style.transition = 'opacity .5s cubic-bezier(.22,.61,.36,1) ' + (i * 70) + 'ms, transform .5s cubic-bezier(.22,.61,.36,1) ' + (i * 70) + 'ms';
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          media.forEach(function (m) { m.style.opacity = ''; m.style.transform = ''; });
        });
      });
    }
    try {
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        if (window.PUB_SUB_EVENTS.variantChange) {
          window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
            if (REDUCE) return;
            $all('.product__info-container .price, .product .price').slice(0, 2).forEach(function (el) {
              el.classList.remove('cx-price-morph');
              void el.offsetWidth;
              el.classList.add('cx-price-morph');
            });
          });
        }
        if (window.PUB_SUB_EVENTS.cartUpdate) {
          window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
            if (REDUCE) return;
            var btn = $('.product-form__submit');
            if (btn) {
              btn.classList.remove('cx-atc-success');
              void btn.offsetWidth;
              btn.classList.add('cx-atc-success');
            }
          });
        }
      }
    } catch (e) {}
  }

  /* ========================================================================
     §3 CART DRAWER INTELLIGENCE
     ===================================================================== */
  function fillCartIntel() {
    var C = eonCfg();
    if (!C) return;
    var box = document.querySelector('[data-cx-cartrec]');
    if (box) {
      var cartSig = box.getAttribute('data-in-cart') || '';
      if (box.__cxFor !== cartSig) {
        box.__cxFor = cartSig;
        var inCart = {};
        cartSig.split(',').forEach(function (id) { if (id) inCart[id.trim()] = 1; });
        var ids = Object.keys(inCart);
        var rail = box.querySelector('[data-cx-cartrec-rail]');
        function renderCards(items, oneTap, rationale) {
          if (!rail || items.length < 2) return false;
          var head = box.querySelector('.cx-cartrec__head');
          if (head) head.textContent = oneTap ? 'Complete your cart' : 'You might also like';
          var lineHtml = (oneTap && rationale) ? '<p class="cx-cartrec__line">' + esc(rationale) + '</p>' : '';
          rail.insertAdjacentHTML('beforebegin', '');
          var old = box.querySelector('.cx-cartrec__line');
          if (old) old.parentNode.removeChild(old);
          if (lineHtml && rail.parentNode) rail.insertAdjacentHTML('beforebegin', lineHtml);
          rail.innerHTML = items.map(function (p) {
            var unit = (p.variant_price != null) ? p.variant_price : p.price_min;
            return '<div class="cx-cartrec__cardwrap">' +
              '<a class="cx-cartrec__card" href="/products/' + encodeURIComponent(p.handle) + '">' +
                '<div class="cx-cartrec__media">' + (p.image_url ? '<img src="' + esc(p.image_url) + '" alt="' + esc(p.title || '') + '" loading="lazy">' : '') + '</div>' +
                '<div class="cx-cartrec__name">' + esc(p.title || '') + '</div>' +
                '<div class="cx-cartrec__price">' + (unit != null ? ngn(unit) : '') + '</div>' +
              '</a>' +
              (p.variant_id ? '<button type="button" class="cx-cartrec__add" data-vid="' + esc(p.variant_id) + '" data-handle="' + esc(p.handle) + '" aria-label="Add ' + esc(p.title || 'piece') + ' to cart">+</button>' : '') +
              '</div>';
          }).join('');
          box.hidden = false;
          if (!rail.__cxBound) {
            rail.__cxBound = 1;
            on(rail, 'click', function (ev) {
              var b = ev.target.closest && ev.target.closest('.cx-cartrec__add');
              if (!b) return;
              ev.preventDefault();
              b.disabled = true;
              var vid = b.getAttribute('data-vid');
              function finish(ok) { b.disabled = false; if (ok) track('cart_look_add', { variant_id: vid }); }
              if (vid) { cxAdd(vid, finish); return; }
              // recommendations card — resolve first available variant, then add
              fetch('/products/' + encodeURIComponent(b.getAttribute('data-handle')) + '.js')
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (p) {
                  var v = p && p.variants && p.variants.filter(function (x) { return x.available; })[0];
                  if (v) cxAdd(v.id, finish); else finish(false);
                }).catch(function () { finish(false); });
            });
          }
          return true;
        }
        // 1) styled cart-look (variant ids → true one-tap)
        fetch(C.base + '/api/storefront/cart-look?shop=' + C.shop + '&product_ids=' + encodeURIComponent(ids.join(',')) + '&limit=6', { mode: 'cors' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var look = (d && d.ok && d.look) || [];
            look = look.filter(function (p) { return p.handle && !inCart[String(p.shopify_id)]; });
            if (renderCards(look, true, d && d.rationale)) { track('cart_look_served', { count: look.length }); return; }
            // 2) fallback — personalised recommendations
            var anon = '';
            try { anon = (window.localStorage && localStorage.getItem('eon_anon')) || ''; } catch (e) {}
            fetch(C.base + '/api/storefront/recommendations?shop=' + C.shop + '&limit=10&anonymous_client_id=' + encodeURIComponent(anon), { mode: 'cors' })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (d2) {
                var items = ((d2 && d2.ok && d2.products) || []).filter(function (p) {
                  return p.handle && !inCart[String(p.shopify_id)];
                }).slice(0, 6);
                renderCards(items, false, '');
              }).catch(function () {});
          })
          .catch(function () {});
      }
    }
    // REAL restock urgency on drawer line items (never invented). No done-flag:
    // renderContents() wipes injected tags, so we re-annotate idempotently
    // (the row check below skips rows that already carry a tag) and only an
    // in-flight flag prevents concurrent storms. /social-proof is 60s-cached.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.__cxUrgBusy) {
      drawer.__cxUrgBusy = true;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        drawer.__cxUrgBusy = false;
        var sig = (cart.items || []).map(function (i) { return i.product_id; }).join(',');
        if (!sig) return;
        fetch(C.base + '/api/storefront/social-proof?shop=' + C.shop + '&product_ids=' + encodeURIComponent(sig), { mode: 'cors' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || !d.ok || !d.items) return;
            (cart.items || []).forEach(function (it) {
              var info = d.items[String(it.product_id)];
              if (!info || info.low_stock == null) return;
              $all('.cart-item a[href*="' + it.handle + '"]', drawer).slice(0, 1).forEach(function (a) {
                var row = a.closest('.cart-item');
                if (!row || row.querySelector('.cx-cart-urgency')) return;
                var tag = document.createElement('span');
                tag.className = 'cx-cart-urgency';
                tag.textContent = 'Only ' + info.low_stock + ' left';
                (a.parentNode || row).appendChild(tag);
              });
            });
          }).catch(function () {});
      }).catch(function () { drawer.__cxUrgBusy = false; });
    }
  }
  function initCartIntel() {
    if (!eonCfg()) return;
    fillCartIntel();
    try {
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(fillCartIntel, 350); });
      }
    } catch (e) {}
    // drawer re-renders replace innerHTML without events in some paths — observe
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(fillCartIntel, 250);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  /* ========================================================================
     §4 SEARCH — "Popular right now" chips
     ===================================================================== */
  function initSearchTrends() {
    var C = eonCfg();
    var boxes = $all('[data-cx-trend]');
    if (!C || !boxes.length) return;
    boxes.forEach(function (box) {
      if (box.__cxTrend) return; box.__cxTrend = 1;
      fetch(C.base + '/api/storefront/recommendations?shop=' + C.shop + '&limit=6', { mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var items = (d && d.ok && d.products) || [];
          if (items.length < 3) return;
          var grid = box.querySelector('[data-cx-trend-chips]');
          if (!grid) return;
          grid.innerHTML = items.map(function (p) {
            return '<a class="cx-search-trend__chip" href="/products/' + encodeURIComponent(p.handle) + '">' + esc(p.title || '') + '</a>';
          }).join('');
          box.hidden = false;
        }).catch(function () {});
    });
  }

  /* ========================================================================
     §5 ASK EON — on-site stylist dock
     ===================================================================== */
  function initAskEon() {
    var root = $('[data-cx-ask]');
    var C = eonCfg();
    if (!root) return;
    if (!C) { root.hidden = true; return; }
    if (root.__cxAsk) return; root.__cxAsk = 1;
    var fab = $('[data-cx-ask-fab]', root);
    var panel = $('[data-cx-ask-panel]', root);
    var scroll = $('[data-cx-ask-scroll]', root);
    var form = $('[data-cx-ask-form]', root);
    var input = $('[data-cx-ask-input]', root);
    var send = $('[data-cx-ask-send]', root);
    if (!fab || !panel || !scroll || !form || !input) return;

    function push(html, anchorToTop) {
      scroll.insertAdjacentHTML('beforeend', html);
      var el = scroll.lastElementChild;
      // An answer with cards can be taller than the panel — anchor the view to
      // the TOP of the reply so the text never buries the picks below the fold
      // (operator 2026-07-03: "the text blocks the suggestions").
      if (anchorToTop && el) scroll.scrollTop = Math.max(0, el.offsetTop - 10);
      else scroll.scrollTop = scroll.scrollHeight;
    }
    function productCards(products) {
      if (!products || !products.length) return '';
      return '<div class="cx-ask__cards">' + products.slice(0, 4).map(function (p) {
        return '<a class="cx-ask__card" href="/products/' + encodeURIComponent(p.handle) + '">' +
          '<span class="cx-ask__im">' + (p.image_url ? '<img src="' + esc(p.image_url) + '" alt="" loading="lazy">' : '') +
            '<span class="cx-ask__imtitle">' + esc(p.title || '') + '</span></span>' +
          '<span class="nm">' + esc(p.title || '') + '</span>' +
          (p.price != null ? '<span class="pr">' + ngn(p.price) + '</span>' : '') +
          '<span class="cta">View</span></a>';
      }).join('') + '</div>';
    }
    var busy = false;
    function ask(q) {
      if (busy || !q) return;
      busy = true;
      if (send) send.disabled = true;
      push('<div class="cx-ask__msg cx-ask__msg--user">' + esc(q) + '</div>');
      push('<div class="cx-ask__typing" data-cx-ask-typing>EON is styling…</div>');
      var ctxObj = (C.raw && C.raw.context) || {};
      fetch('/cart.js').then(function (r) { return r.ok ? r.json() : { items: [] }; }).catch(function () { return { items: [] }; })
        .then(function (cart) {
          var body = {
            question: q,
            product_id: ctxObj.productId ? String(ctxObj.productId) : null,
            cart_product_ids: (cart.items || []).map(function (i) { return String(i.product_id); }).slice(0, 20)
          };
          var ctrl = ('AbortController' in window) ? new AbortController() : null;
          var to = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 30000) : null;
          return fetch(C.base + '/api/storefront/ask?shop=' + C.shop, {
            method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined
          }).then(function (r) { if (to) clearTimeout(to); return r.ok ? r.json() : null; });
        })
        .then(function (d) {
          var t = $('[data-cx-ask-typing]', scroll);
          if (t) t.parentNode.removeChild(t);
          busy = false;
          if (send) send.disabled = false;
          if (!d || !d.ok || !d.answer) {
            push('<div class="cx-ask__msg cx-ask__msg--eon"><span class="who">EON</span>I could not style that just now — try again in a moment, or message us on WhatsApp.</div>');
            return;
          }
          push('<div class="cx-ask__msg cx-ask__msg--eon"><span class="who">EON · your stylist</span>' + esc(d.answer) + productCards(d.products) + '</div>', true);
          track('ask_eon', { q_len: q.length, products: (d.products || []).length });
        })
        .catch(function () {
          var t = $('[data-cx-ask-typing]', scroll);
          if (t) t.parentNode.removeChild(t);
          busy = false;
          if (send) send.disabled = false;
          push('<div class="cx-ask__msg cx-ask__msg--eon"><span class="who">EON</span>Connection hiccup — try again.</div>');
        });
    }
    on(fab, 'click', function () {
      var open = !panel.hidden;
      panel.hidden = open;
      fab.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) { input.focus(); track('ask_eon_open', {}); }
    });
    on($('[data-cx-ask-close]', root), 'click', function () { panel.hidden = true; fab.setAttribute('aria-expanded', 'false'); });
    on(document, 'keydown', function (ev) { if (ev.key === 'Escape' && !panel.hidden) panel.hidden = true; });
    on(form, 'submit', function (ev) {
      ev.preventDefault();
      var q = (input.value || '').trim();
      if (!q) return;
      input.value = '';
      ask(q);
    });
    on(scroll, 'click', function (ev) {
      var chip = ev.target.closest && ev.target.closest('.cx-ask__chip');
      if (chip) ask(chip.textContent.trim());
    });
  }

  /* ========================================================================
     §6 DROP SCENE — IO fallback for no-scroll-timeline browsers
     ===================================================================== */
  function initDropScene() {
    var scenes = $all('.cx-dropscene');
    if (!scenes.length) return;
    var hasTimeline = false;
    try { hasTimeline = CSS.supports('animation-timeline: view()'); } catch (e) {}
    if (hasTimeline && !REDUCE) return; // CSS owns it
    if (!('IntersectionObserver' in window)) {
      scenes.forEach(function (s) { s.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); } });
    }, { threshold: 0.25 });
    scenes.forEach(function (s) { io.observe(s); });
  }

  /* ========================================================================
     §7 STORE-AWARE PDP — "In store — Palms · Abuja" under the buy box.
     Real per-door stock from /api/storefront/availability (retail doors
     only, low-stock flagged). 90% of revenue walks through those doors;
     the PDP finally says so. Fails open — no data, no line.
     ===================================================================== */
  function initStoreAvailability() {
    var C = eonCfg();
    if (!C) return;
    if (!document.body.className.match(/template-product/)) return;
    var ctxObj = (C.raw && C.raw.context) || {};
    if (!ctxObj.productId || document.querySelector('.cx-instore')) return;
    var host = $('.product__info-container .product-form') || $('.product__info-container form[action*="/cart/add"]');
    if (!host) return;
    fetch(C.base + '/api/storefront/availability?shop=' + C.shop + '&product_id=' + encodeURIComponent(ctxObj.productId), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.ok || !d.stores || !d.stores.length) return;
        var names = d.stores.map(function (s) { return esc(s.name) + (s.low ? ' <em>(few left)</em>' : ''); });
        var line = document.createElement('p');
        line.className = 'cx-instore';
        line.innerHTML = '<span class="d" aria-hidden="true"></span>In store — ' + names.join(' · ');
        host.parentNode.insertBefore(line, host.nextSibling);
        track('instore_line_served', { product_id: ctxObj.productId, stores: d.stores.length });
      }).catch(function () {});
  }

  function boot() {
    initCardTray();
    initPdpMotion();
    initCartIntel();
    initSearchTrends();
    initAskEon();
    initDropScene();
    initStoreAvailability();
  }
  ready(boot);
  document.addEventListener('shopify:section:load', function () { initSearchTrends(); initDropScene(); });
})();
